import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
//api
import { getCountries } from 'api/company';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchCountry = ({ 
  filterBy, 
  onSelected, 
  placeholder, 
  defaultCountry = null 
}) => {
  const { t } = useTranslation(['backoffice']);
  const [countrySelected, setCountrySelected] = useState(null);

  useEffect(() => {
    if (defaultCountry) {
      setCountrySelected({
        label: defaultCountry[filterBy],
        value: defaultCountry.id,
      });
    } else setCountrySelected(null)
  }, [defaultCountry]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getCountries({ [filterBy]: value, page: 1, page_size: 10 });
      if (status === 200) {
        return data?.map((item) => ({
          ...item,
          label: item[filterBy],
          value: item.id,
        }));
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      label={t('pais')}
      placeholder={placeholder}
      defaultOptions={countrySelected ? [countrySelected] : []}
      defaultValue={countrySelected}
      onSelect={onSelected}
      onSearch={onSearch}
    />
  );
};

SearchCountry.propTypes = {
  filterBy: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
  defaultCountry: PropTypes.any,
};

export default SearchCountry;
